import $ from 'jquery'
import * as ViewportServices from '../../services/Viewport'
import { loadComponents, removeComponents } from '../componentUtils'
import { queries } from '../config'

import Cache from './cache'
import Link from './link'
import enquire from 'enquire.js'
import gtmEvent from './gtmEvent'
import transitionEnd from './transitionEnd'
import getDataFromHtml from './getDataFromHtml'
import EventBus from '../EventBus'

export default class xhrController {
    constructor(options) {
        this.$body = $('body')
        this.$container = $('#xhr')
        this.previousUrl
        this.getUrl()
        this.current = this.previousUrl
        this.next = ''
        this.LINK_SELECTOR =
            'a[href^="/"]:not([data-no-transition]):not([href^="/data"]):not([href^="/files"]):not([data-trigger]):not([data-img-size]):not(.ajax):not([data-component="LoadMore"]), a[href^="#"]:not([data-no-transition]), a[xlink\\:href]'
        this.xhrForms = $('form.xhr-form')
        this.mobile = false
        this.scrollToElement = null

        // make accessible in object
        this.cache = new Cache()
        this.link = Link
        this.gtmEvent = gtmEvent
        this.transitionEnd = transitionEnd
        this.getDataFromHtml = getDataFromHtml

        enquire.register(queries.smallWideMax, {
            match: () => {
                this.mobile = true
            },
        })

        this.options = options
        $(document).trigger('load:afterRender')
        this.prepare()
    }

    prepare() {
        var self = this
        // support check
        if (!('pushState' in window.history) || this.$body.data('page-transition') === false) {
            return
        }
        if (this.$body.hasClass('cms')) {
            return
        }
        if (this.options.duration.auto && transitionEnd()) {
            this.transitionEnd = transitionEnd()
        } else if (this.options.duration.auto && !transitionEnd()) {
            return
        }

        // links
        $(document).on('click', this.LINK_SELECTOR, (event) => {
            // no control key pressed
            if (!event.metaKey) {
                var link = new Link()
                event.preventDefault()
                link.setPath(event.currentTarget.href)
                if (link.getPath() == this.current || link.getPath() == '') {
                    if (link.getHash() != '') {
                        var $element = $(link.getHash())
                        if ($element.length) {
                            ViewportServices.scrollTo($element.offset().top)
                            history.replaceState(undefined, undefined, link.getHash())
                        } else {
                            console.warn('Element for offset not found (' + link.getHash() + ')')
                        }
                    }
                } else {
                    if (link.getHash() != '') {
                        this.scrollToElement = link.getHash()
                    }
                    this.loadPage(link.getPath(), false)
                }
            }
        })

        // forms
        $(document).on('submit', 'form.xhr-form', (event) => {
            event.preventDefault()
            var $form = $(event.currentTarget)
            this.current = $form.attr('action')
            var finalPage = null

            // handle classes and events before unload
            $(document).trigger('load:beforeLeave')
            this.$body.addClass('show-loading')
            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: $form.serialize(),
                success: (response, status, xhr) => {
                    // get json data
                    var ct = xhr.getResponseHeader('content-type') || ''
                    if (ct.indexOf('html') > -1) {
                        var page = getDataFromHtml(response)
                    }
                    if (ct.indexOf('json') > -1) {
                        var page = response
                        if (response.redirect !== null) {
                            this.loadPage(response.redirect, event)
                            return
                        }
                    }
                    // render page
                    finalPage = page
                    this.renderPage(finalPage, event)
                },
            })
        })

        // history
        window.onpopstate = (event) => {
            var link = new Link()
            link.setPath(
                event.state && event.state.url
                    ? event.state.url
                    : window.location.pathname + window.location.search,
            )
            if (link.getHash() != '') {
                this.scrollToElement = link.getHash()
            } else {
                event.preventDefault()
            }
            console.log(link.getSearch())
            self.loadPage(link.getPath() + link.getSearch(), event)
        }

        // save to cache & initial GTM event
        var page = getDataFromHtml($(document).find('html').html())
        page.url = this.previousUrl
        if (self.options.cache) self.cache.cacheUrl(page)
        if (self.options.gtm) gtmEvent(page.url, page.title)
    }

    loadPage(url, popstate) {
        var self = this
        this.current = url
        // var xhrUrl = url + '?xhr';
        var xhrUrl = url
        var finalPage = null

        // handle classes and events before unload
        $(document).trigger('load:beforeLeave')
        if (!popstate) {
            for (var i = 0; i < this.options.specialPages.length; i++) {
                if (url == this.options.specialPages[i].url) {
                    this.$body.addClass(this.options.specialPages[i].class)
                }
            }
        }

        if (!popstate && !this.scrollToElement) {
            if (this.mobile) {
                setTimeout(() => {
                    $('html').addClass('androidFix')
                    this.$body.scrollTop(0)
                    window.scrollTop = 0
                    $('html').scrollTop(0)
                }, 600)
            } else {
                setTimeout(() => {
                    if (this.$body.scrollTop() > 400) {
                        this.$body.scrollTop(400)
                    }
                }, 600)

                setTimeout(() => {
                    ViewportServices.scrollTo(0)
                }, 700)
            }
        }

        if (!popstate) {
            this.$body.addClass('is-changing')
            this.$body.addClass('is-leaving')

            var animationDone = false
            if (!this.options.duration.auto) {
                setTimeout(function () {
                    animationDone = true
                }, this.options.duration.out)
            } else {
                let $animatedElements = $(this.options.duration.className)
                let promises = []
                $animatedElements.each(function () {
                    var $this = $(this)
                    var promise = new Promise((resolve) => {
                        $this.on(self.transitionEnd, resolve)
                    })
                    promises.push(promise)
                })

                Promise.all(promises).then(function () {
                    console.log('Animation OUT done')
                    animationDone = true
                })
            }

            if (this.scrollToElement != null) {
                var pop = url + this.scrollToElement
            } else {
                var pop = url
            }
            this.createState(pop)
        } else {
            var animationDone = true
        }

        if (this.cache.exists(url)) {
            // render page
            finalPage = this.cache.getPage(url)

            if (!popstate && !this.options.duration.auto) {
                setTimeout(() => {
                    proceed(popstate)
                }, this.options.duration.out)
            } else {
                proceed(popstate)
            }
        } else {
            $.ajax({
                url: xhrUrl,
                type: 'POST',
                success: (response, status, xhr) => {
                    // get json data
                    var ct = xhr.getResponseHeader('content-type') || ''
                    if (ct.indexOf('html') > -1) {
                        var page = getDataFromHtml(response)
                    }
                    if (ct.indexOf('json') > -1) {
                        var page = response
                    }
                    page.url = url
                    // render page
                    finalPage = page
                    if (this.options.cache) this.cache.cacheUrl(page)
                    proceed(false)
                },
                //error: (response, status, xhr) => {
                //    console.log(xhr)
                //    if (xhr == 'Not Found') {
                //        // get json data
                //        var ct = xhr.getResponseHeader("content-type") || "";
                //        if (ct.indexOf('html') > -1) {
                //            var page = getDataFromHtml(response);
                //        }
                //        if (ct.indexOf('json') > -1) {
                //            var page = response;
                //        }
                //        page.url = url;
                //        // render page
                //        finalPage = page;
                //        if (this.options.cache)
                //            this.cache.cacheUrl(page);
                //        proceed(false);
                //    } else {
                //        console.warn('Server error.');
                //        this.goBack();
                //    }
                //}
            })
        }

        function proceed(popstate) {
            if (animationDone) {
                self.renderPage(finalPage, popstate)
            } else {
                var loop = setInterval(function () {
                    if (animationDone) {
                        self.renderPage(finalPage, popstate)
                        clearInterval(loop)
                    }
                }, 100)
            }
        }
    }

    renderPage(page, popstate) {
        EventBus.emit('swup:beforerender')
        removeComponents(this.$container)

        var self = this
        this.$body.removeClass('is-leaving')
        this.$body.addClass('is-rendering')
        this.$container.html(page.content)
        loadComponents(this.$container)

        // replace special elements
        for (var i = 0; i < this.options.specialElements.length; i++) {
            if ($(page.originalContent).find(this.options.specialElements[i]).length == 0) {
                console.warn(
                    'Element to be replaced (' +
                        this.options.specialElements[i] +
                        ') is not found in received page.',
                )
            } else if (this.$body.find(this.options.specialElements[i]).length == 0) {
                console.warn(
                    'Element to be replaced (' +
                        this.options.specialElements[i] +
                        ') is not found current html.',
                )
            } else {
                this.$body
                    .find(this.options.specialElements[i])
                    .replaceWith(
                        $(page.originalContent).find(this.options.specialElements[i])[0].outerHTML,
                    )
            }
        }

        // handle classes after render
        this.$body.removeClass(function (index, className) {
            return (className.match(/(^|\s)page-\S+/g) || []).join(' ')
        })
        this.$body.addClass(page.pageClass)

        if (this.options.gtm) gtmEvent(page.url, page.title)
        this.loadNette()

        $(document).trigger('load:afterRender')
        EventBus.emit('swup:afterrender')

        // set title
        document.title = page.title

        // scroll to hash element
        if (this.scrollToElement) {
            var $element = $(this.scrollToElement)
            if ($element.length) {
                document.documentElement.scrollTop = $element.offset().top
            } else {
                console.warn('Element for offset not found (' + this.scrollToElement + ')')
            }
            this.scrollToElement = null
        }

        setTimeout(() => {
            this.$body.removeClass('is-changing')
            this.$body.removeClass('is-rendering')
            // handle special classes for specific pages
            for (var i = 0; i < this.options.specialPages.length; i++) {
                this.$body.removeClass(this.options.specialPages[i].class)
            }
        }, 100)

        // animation
        if (this.options.duration.auto) {
            let $animatedElements = $(this.options.duration.className)
            let promises = []
            $animatedElements.each(function () {
                var $this = $(this)
                var promise = new Promise((resolve) => {
                    $this.on(self.transitionEnd, resolve)
                })
                promises.push(promise)
            })

            Promise.all(promises).then(function () {
                console.log('Animation IN done')
                self.$body.removeClass('is-rendering')
            })
        }

        this.getUrl()
    }

    goBack(page, popstate) {
        $(document).trigger('load:afterRender')
        setTimeout(() => {
            this.$body.removeClass('is-changing')
            history.back()
            for (var i = 0; i < this.options.specialPages.length; i++) {
                this.$body.removeClass(this.options.specialPages[i].class)
            }
        }, 100)
    }

    createState(url) {
        window.history.pushState(
            {
                url: url || window.location.href.split(window.location.hostname)[1],
                random: Math.random(),
            },
            $('html').find('title').text(),
            url || window.location.href.split(window.location.hostname)[1],
        )
    }

    getUrl() {
        this.previousUrl = window.location.pathname + window.location.search
    }

    loadNette() {
        //console.log($.nette)
        if ($.nette) {
            $.nette.ext('snippets').afterQueue.fire(this.$container)
            $.nette.load()
        }
    }
}



// WEBPACK FOOTER //
// ./core/xhrController/core.js